import { z } from 'zod';

export const personSchema = z.object({
  full_name: z.string().min(2, 'Name must be at least 2 characters'),
  email: z.string().email('Invalid email address').nullable().or(z.literal('')),
  employee_id: z.string().nullable().or(z.literal('')),
  title: z.string().nullable().or(z.literal('')),
  phone: z.string().nullable().or(z.literal('')),
  notes: z.string().nullable().or(z.literal('')),
  department_id: z.string().nullable(),
  location_id: z.string().nullable(),
});

export type PersonFormValues = z.infer<typeof personSchema>;
